import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const NavigationTour = ({ autoStart = false, onComplete }) => {
  const { startTour } = useShepherdTour('navigation', TOUR_DATA.navigation.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Navigation Tour
    </button> */}
    </>
  );
};

export default NavigationTour;
